import { render, staticRenderFns } from "./editBudget.vue?vue&type=template&id=9966b954&"
import script from "./editBudget.vue?vue&type=script&lang=js&"
export * from "./editBudget.vue?vue&type=script&lang=js&"
import style0 from "./editBudget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports